import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import type { ApiError } from '../types';
import { PolicyType } from '../../types';

const END_POINT = '/metric/policyType';

type PolicyTypeDto = PolicyType;

const convertToPolicyType = (data: PolicyTypeDto): PolicyType => {
    return {
        total: {
            static: data.total.static,
            riskBased: data.total.riskBased
        },
        active: {
            static: data.active.static,
            riskBased: data.active.riskBased
        },
        disabled: {
            static: data.disabled.static,
            riskBased: data.disabled.riskBased
        }
    };
};

const fetchPolicyType = async (): Promise<PolicyTypeDto> => {
    const data = await apiGet<PolicyTypeDto>(`${API_BASE_URL}${END_POINT}`);
    return data;
};

export const usePolicyType = (): UseQueryResult<PolicyType, ApiError> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.policyType(),
        queryFn: () => fetchPolicyType(),
        select: convertToPolicyType
    });
};
